export function toTrimmedQuestionLabels(questions: string[]): string[] {
  return questions.map((question) => question.trim()).filter(Boolean);
}
